import type { VideoRenderer } from './types';

/** Keeps pairing/diagnostics available without pretending to decode projection video. */
export class UnsupportedVideoRenderer implements VideoRenderer {
  private canvas: HTMLCanvasElement | null = null;

  public async initialize(canvas: HTMLCanvasElement): Promise<void> {
    this.canvas = canvas;
    this.reset();
  }

  public renderFrame(): void {
    throw new Error('H.264 decoding unavailable in this browser');
  }

  public reset(): void {
    const canvas = this.canvas;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#ffffff';
    ctx.font = '20px sans-serif';
    ctx.fillText('Browser cannot decode Android Auto video', 20, 40);
  }

  public destroy(): void { this.canvas = null; }
  public getFps(): number { return 0; }
  public getName(): string { return 'Unsupported: H.264 decoder unavailable'; }
}
